// Header.jsx
import React, { useState } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

// Importe as bandeiras
import braFlag from '../../images/lang/bra.png';
import usaFlag from '../../images/lang/usa.png';
import labLogo from '../../images/lab/lablogo.png';

function Header() {
  const { t, switchLanguage } = useLanguage();

  // Estado para controlar o menu (aberto / fechado)
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Função que alterna o estado do menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header-container">
      {/* Logo que leva à Home */}
      <div className="lab-name">
        <Link to="/" className="lab-link">
          <img src={labLogo} alt="Lab Logo" className="lab-logo" />
        </Link>
      </div>

      {/* Ícone hambúrguer (somente aparece em mobile) */}
      <div className="hamburger" onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      {/* Container para nav-links e language-buttons
          Aplica a classe 'open' quando o menu estiver aberto */}
      <div className={`right-section ${isMenuOpen ? 'open' : ''}`}>
        <nav className="nav-links">
          <Link to="/research" onClick={() => setIsMenuOpen(false)}>
            {t('navResearch')}
          </Link>
          <Link to="/team" onClick={() => setIsMenuOpen(false)}>
            {t('navTeam')}
          </Link>
          <Link to="/tools" onClick={() => setIsMenuOpen(false)}>
            {t('navTools')}
          </Link>
          <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
            {t('navContact')}
          </Link>
        </nav>

        <div className="language-buttons">
          <button className="lang-button" onClick={() => switchLanguage('en')}>
            <img src={usaFlag} alt="English" />
          </button>
          <button className="lang-button" onClick={() => switchLanguage('pt')}>
            <img src={braFlag} alt="Português" />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
